import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-end gap-2" }

import { onBeforeMount, toRef, ref } from 'vue';
import useWithdrawMath from '@/components/forms/pool_actions/WithdrawForm/composables/useWithdrawMath';
import { FullPool } from '@/services/balancer/subgraph/types';
import useTokens from '@/composables/useTokens';
import useNumbers from '@/composables/useNumbers';
import useUserSettings from '@/composables/useUserSettings';
import FarmPreviewModal from '@/components/modals/FarmPreviewModal.vue';
import useWeb3 from '@/services/web3/useWeb3';

/**
 * TYPES
 */
type Props = {
  pool: FullPool;
  missingPrices: boolean;
  isIncentivized: string;
};

/**
 * PROPS
 */

export default _defineComponent({
  props: {
    pool: { type: null, required: true },
    missingPrices: { type: Boolean, required: true },
    isIncentivized: { type: String, required: true }
  } as unknown as undefined,
  setup(__props: {
  pool: FullPool;
  missingPrices: boolean;
  isIncentivized: string;
}) {

const props = __props

/**
 * COMPOSABLES
 */
const { initMath, hasBpt } = useWithdrawMath(toRef(props, 'pool'));
const { balanceFor, nativeAsset, wrappedNativeAsset } = useTokens();
const modalFarmPreviewOpen = ref(false);
const { fNum, toFiat } = useNumbers();
const { currency } = useUserSettings();
const { isWalletReady, toggleWalletSelectModal } = useWeb3();
const isIncentivized = props.isIncentivized;
/**
 * COMPUTED
 */
// const fiatTotal = computed(() => {
//   const fiatValue = props.pool.tokenAddresses
//     .map(address => {
//       let tokenBalance = '0';

//       if (address === wrappedNativeAsset.value.address) {
//         const wrappedBalance = balanceFor(address);
//         const nativeBalance = balanceFor(nativeAsset.address);
//         tokenBalance = bnum(nativeBalance).gt(wrappedBalance) ? nativeBalance : wrappedBalance;
//       } else {
//         tokenBalance = balanceFor(address);
//       }

//       return toFiat(tokenBalance, address);
//     })
//     .reduce((total, value) =>
//       bnum(total)
//         .plus(value)
//         .toString()
//     );

//   return fNum(fiatValue, currency.value);
// });

// const hasUnstakedBpt = computed(() => props.pool.farm && parseFloat(balanceFor(getAddress(props.pool.address))) > 0);

// const hasFarm = computed(
//   () =>
//     !!props.pool.farm ||
//     props.pool.address == '0x011C0Eb92053B64cBF6bEF9dFC9EE3005ce6c167' ||
//     props.pool.address == '0x9042D74bDf78fdB27005C8065F49Cfc20ec4296c'
// );

// const hasFarmStake = computed(() => props.pool.farm?.stake && props.pool.farm.stake > 0);

// const farmId = computed(() => props.pool.farm?.id || '');
// const tokenAddress = computed(() => props.pool.address);
// const hasFarmRewards = computed(() => props.pool.farm?.rewards || 0 > 0);

function showFarmPreviewModal() {
  modalFarmPreviewOpen.value = true;
}

/**
 * CALLBACKS
 */
onBeforeMount(() => {
  initMath();
});

return (_ctx: any,_cache: any) => {
  const _component_BalBtn = _resolveComponent("BalBtn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BalBtn, {
        tag: "router-link",
        to: { name: 'invest' },
        label: _ctx.$t('invest'),
        color: "gradient",
        rounded: true,
        block: ""
      }, null, 8, ["label"]),
      _createVNode(_component_BalBtn, {
        tag: _unref(hasBpt) ? 'router-link' : 'div',
        to: { name: 'withdraw' },
        label: _ctx.$t('withdraw.label'),
        disabled: !_unref(hasBpt),
        rounded: true,
        block: ""
      }, null, 8, ["tag", "label", "disabled"]),
      (_unref(isIncentivized) === 'true')
        ? (_openBlock(), _createBlock(_component_BalBtn, {
            key: 0,
            label: _ctx.$t('farm'),
            color: "gradient",
            block: "",
            onClick: _withModifiers(showFarmPreviewModal, ["prevent"]),
            rounded: true
          }, null, 8, ["label", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      (modalFarmPreviewOpen.value)
        ? (_openBlock(), _createBlock(FarmPreviewModal, {
            key: 0,
            pool: props.pool,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (modalFarmPreviewOpen.value = false))
          }, null, 8, ["pool"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})